import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { getList } from '@/api/setting/dictionary';
import XLSX from 'xlsx';
import { toBatchSend } from '@/api/correspondence/task/form';
export default {
  name: 'batch-send',
  data: function data() {
    return {
      activeNames: undefined,
      tableData: [],
      correspondenceTypes: [],
      defaultDataItems: ['shunfeng', 'shunfengkuaiyun', 'youzhengguonei', 'ems', 'yuantong', 'shentong', 'shentong', 'yunda', 'jd', 'debangkuaidi', 'dhl', 'fedex', 'ups'],
      costTypes: [{
        name: '被审客户',
        value: '被审客户'
      }, {
        name: '本所部组',
        value: '本所部组'
      }, {
        name: '不适用',
        value: '不适用'
      }],
      localStorageName: 'cpscc-correspondence-send-model',
      costStates: [{
        name: '待结算',
        value: '待结算'
      }, {
        name: '已回收',
        value: '已回收'
      }, {
        name: '待回收',
        value: '待回收'
      }, {
        name: '不适用',
        value: '不适用'
      }],
      model: {
        c02SendType: '邮寄发函',
        c02SendAddress: '',
        c02SendDate: dayjs().format('YYYY-MM-DD'),
        c02SendProcess: '项目组寄回已盖章纸质询证函，函证中心统一下单寄出',
        c02SendCompany: '顺丰速运'
      },
      loading: false,
      errorCodes: undefined
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('cpscc', ['sendCompany', 'userInfo', 'isHX'])), mapState('d2admin/user', ['info'])), {}, {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    }
  }),
  methods: {
    updateModelValues: function updateModelValues(value) {
      localStorage.setItem(this.localStorageName, JSON.stringify(value));
    },
    getModelValues: function getModelValues() {
      var res = localStorage.getItem(this.localStorageName);
      if (res) {
        var obj = JSON.parse(res);
        for (var key in obj) {
          if (obj.hasOwnProperty(key) && key !== 'c02SendDate') {
            this.model[key] = obj[key];
          }
        }
      } else {
        if (this.isHX) {
          this.model.c02SendType = '邮寄发函';
          this.model.c02SendProcess = '项目组寄回已盖章纸质询证函，函证中心统一下单寄出';
          this.model.c02SendCompany = '顺丰速运';
        }
      }
    },
    cancel: function cancel() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.$emit('cancel');
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit: function submit(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.errorCodes = undefined;
              _context2.n = 1;
              return _this2.$confirm('', {
                title: '请认真核定信息',
                confirmButtonText: '我已复核信息'
              });
            case 1:
              _this2.loading = true;
              _context2.n = 2;
              return _this2.$awaitTo(toBatchSend(_this2.tableData.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  isSent: type
                });
              })));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              if (!(Array.isArray(data) && data.length)) {
                _context2.n = 4;
                break;
              }
              _this2.errorCodes = data.join('、');
              return _context2.a(2);
            case 4:
              _this2.$message.success('操作成功');
              // this.$emit('submit')
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getOptions: function getOptions(type, key) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: type
              }));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1].data;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, Promise.reject());
            case 2:
              if (Array.isArray(data.datas)) {
                _this3[key] = data.datas;
              }
              return _context3.a(2, Promise.resolve());
          }
        }, _callee3);
      }))();
    },
    fileChange: function fileChange(files) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var d, allData, list;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(files && files.length)) {
                _context4.n = 2;
                break;
              }
              d = files.map(function (file) {
                return _this4.transformExcelData(file);
              });
              _context4.n = 1;
              return Promise.all(d);
            case 1:
              allData = _context4.v;
              if (Array.isArray(allData)) {
                list = allData.flat(Infinity);
                _this4.updateTableData(list);
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    fileChange2: function fileChange2(files) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var d, allData, list;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(files && files.length)) {
                _context5.n = 2;
                break;
              }
              d = files.map(function (file) {
                return _this5.transformExcelData2(file);
              });
              _context5.n = 1;
              return Promise.all(d);
            case 1:
              allData = _context5.v;
              if (Array.isArray(allData)) {
                list = allData.flat(Infinity);
                _this5.updateTableData(list);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    transformExcelData2: function transformExcelData2(file) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2, new Promise(function (resolve, reject) {
                var reader = new FileReader();
                var self = _this6;
                reader.readAsBinaryString(file);
                reader.onload = function (ev) {
                  var data = ev.target.result;
                  var wb = XLSX.read(data, {
                    type: 'binary'
                  });
                  var jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                  if (Array.isArray(jsonData) && jsonData.length) {
                    var excelData = [];
                    var _loop = function _loop(i) {
                      if (jsonData[i]['订单备注']) {
                        var codes = jsonData[i]['订单备注'].split(',').filter(function (item) {
                          return item;
                        });
                        if (codes.length > 1) {
                          codes.forEach(function (item) {
                            excelData.push({
                              c02ConfirmCode: item,
                              c02SendType: undefined,
                              c02SendAddress: undefined,
                              c02SendDate: undefined,
                              c02SendProcess: undefined,
                              c02SendCompany: undefined,
                              c02SendNumber: jsonData[i]['运单号'],
                              c02SendFee: 0,
                              c02SendBelong: '不适用',
                              c02SendFeeStatus: '不适用',
                              c02SendStaff: undefined
                            });
                          });
                        } else {
                          excelData.push({
                            c02ConfirmCode: codes[0],
                            c02SendType: undefined,
                            c02SendAddress: undefined,
                            c02SendDate: undefined,
                            c02SendProcess: undefined,
                            c02SendCompany: undefined,
                            c02SendNumber: jsonData[i]['运单号'],
                            c02SendFee: 0,
                            c02SendBelong: '不适用',
                            c02SendFeeStatus: '不适用',
                            c02SendStaff: undefined
                          });
                        }
                      } else {
                        self.$message.warning("\u7B2C".concat(i + 1, "\u6761\u7F3A\u5C11\u51FD\u8BC1\u7F16\u7801"));
                        reject(new Error('没有数据'));
                        return 1; // break
                      }
                    };
                    for (var i = 0; i < jsonData.length; i++) {
                      if (_loop(i)) break;
                    }
                    resolve(excelData);
                  } else {
                    this.$message.warning('没有数据');
                    reject(new Error('没有数据'));
                  }
                };
              }));
          }
        }, _callee6);
      }))();
    },
    transformExcelData: function transformExcelData(file) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              return _context7.a(2, new Promise(function (resolve, reject) {
                var reader = new FileReader();
                var self = _this7;
                reader.readAsBinaryString(file);
                reader.onload = function (ev) {
                  var data = ev.target.result;
                  var wb = XLSX.read(data, {
                    type: 'binary'
                  });
                  var jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                  if (Array.isArray(jsonData) && jsonData.length) {
                    var excelData = [];
                    var _loop2 = function _loop2(i) {
                      if (jsonData[i]['寄方备注']) {
                        var codes = jsonData[i]['寄方备注'].split(',').filter(function (item) {
                          return item;
                        });
                        if (codes.length > 1) {
                          codes.forEach(function (item) {
                            excelData.push({
                              c02ConfirmCode: item,
                              c02SendType: undefined,
                              c02SendAddress: undefined,
                              c02SendDate: undefined,
                              c02SendProcess: undefined,
                              c02SendCompany: undefined,
                              c02SendNumber: jsonData[i]['运单号'],
                              c02SendFee: 0,
                              c02SendBelong: '不适用',
                              c02SendFeeStatus: '不适用',
                              c02SendStaff: undefined
                            });
                          });
                        } else {
                          excelData.push({
                            c02ConfirmCode: codes[0],
                            c02SendType: undefined,
                            c02SendAddress: undefined,
                            c02SendDate: undefined,
                            c02SendProcess: undefined,
                            c02SendCompany: undefined,
                            c02SendNumber: jsonData[i]['运单号'],
                            c02SendFee: 0,
                            c02SendBelong: '不适用',
                            c02SendFeeStatus: '不适用',
                            c02SendStaff: undefined
                          });
                        }
                      } else {
                        self.$message.warning("\u7B2C".concat(i + 1, "\u6761\u7F3A\u5C11\u51FD\u8BC1\u7F16\u7801"));
                        reject(new Error('没有数据'));
                        return 1; // break
                      }
                    };
                    for (var i = 0; i < jsonData.length; i++) {
                      if (_loop2(i)) break;
                    }
                    resolve(excelData);
                  } else {
                    this.$message.warning('没有数据');
                    reject(new Error('没有数据'));
                  }
                };
              }));
          }
        }, _callee7);
      }))();
    },
    updateTableData: function updateTableData(data) {
      var _this8 = this;
      if (!this.model.c02SendType || !this.model.c02SendProcess || !this.model.c02SendCompany) {
        this.$message.error('请先完善默认带入数据');
        return;
      }
      var d = Array.isArray(data) ? data : this.tableData;
      this.tableData = d.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          c02SendType: _this8.model.c02SendType,
          c02SendAddress: _this8.model.c02SendAddress,
          c02SendDate: _this8.model.c02SendDate,
          c02SendProcess: _this8.model.c02SendProcess,
          c02SendCompany: _this8.model.c02SendCompany,
          c02SendStaff: "\u51FD\u8BC1\u4E2D\u5FC3(".concat(_this8.isAdmin ? '管理员' : _this8.info.name, ")")
        });
      });
      this.updateModelValues(this.model);
    },
    handleFeeChange: function handleFeeChange(val, row) {
      if (!val) {
        row.c02SendFee = 0;
      }
      if (row.c02SendFee === 0) {
        row.c02SendBelong = '不适用';
        row.c02SendFeeStatus = '不适用';
      } else {
        row.c02SendBelong = '被审客户';
        row.c02SendFeeStatus = '待回收';
      }
    },
    sendDateChange: function sendDateChange() {
      if (this.baseForm.c02SendType !== '邮寄发函') {
        this.baseForm.c02SendRecDate = this.baseForm.c02SendDate ? dayjs(this.baseForm.c02SendDate).add(2, 'day').format('YYYY-MM-DD') : undefined;
      }
    },
    cellClassName: function cellClassName(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 4) {
        return 'app-highlight-table-item';
      }
      return '';
    },
    sendTypeChange: function sendTypeChange(val) {
      var params = {
        c02SendCompany: undefined,
        c02SendNumber: undefined,
        c02SendFee: undefined,
        c02SendBelong: undefined,
        c02SendFeeStatus: undefined,
        c02SendRecAddress: undefined
      };
      if (val !== '邮寄发函') {
        params.c02SendCompany = 'N/A';
        params.c02SendNumber = 'N/A';
        params.c02SendFee = 0;
        params.c02SendBelong = '不适用';
        params.c02SendFeeStatus = '不适用';
        params.c02SendRecAddress = this.baseForm.c02ObjAddress;
        this.sendDateChange();
        this.baseForm = _objectSpread(_objectSpread({}, this.baseForm), params);
      }
    }
  },
  created: function created() {
    this.getOptions('c02SendType', 'correspondenceTypes');
    this.$store.dispatch('cpscc/getExpressInfo');
    this.getModelValues();
  }
};